import ChatGptRecommendation from "@/assets/images/ai/chatgpt.png";
import GeminiRecommendation from "@/assets/images/ai/gemini.png";
import { Heading } from "@/components/typography/Heading";

const recommendations = [
  {
    alt: "توصية ChatGPT بمنصة أوراق",
    image: ChatGptRecommendation,
    source: "ChatGPT",
    hex: "#10A37F",
    bg: "#212121", // matching ChatGPT dark mode bg
    fadeHeight: "h-80", // More fade
    fadePercentage: "15%",
  },
  {
    alt: "توصية Gemini بمنصة أوراق",
    image: GeminiRecommendation,
    source: "Gemini",
    hex: "#4285F4",
    bg: "#131314", // matching Gemini dark mode bg
    fadeHeight: "h-50", // More fade
    fadePercentage: "35%",
  },
];

export default function AIRecommendations() {
  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      {/* Top: Header */}
      <div className="mb-16 text-center">
        <Heading level={2} size="section">
          حتى الذكاء الاصطناعي ينصح بنا
        </Heading>
      </div>

      {/* Bottom: Screenshots */}
      <div className="flex flex-col items-center justify-center gap-10 sm:flex-row sm:items-start sm:gap-8">
        {recommendations.map((rec, index) => (
          <div
            key={rec.source}
            className={`relative w-full max-w-[400px] transition-transform duration-700 hover:-translate-y-2 sm:max-w-[450px] ${
              index === 1 ? "sm:mt-16" : ""
            }`}
          >
            {/* Soft glow behind the card */}
            <div
              className="absolute inset-0 -z-10 rounded-[2rem] opacity-15 blur-2xl"
              style={{ backgroundColor: rec.hex }}
            />

            {/* Card Container - Solid dark background instead of mask-image */}
            <div
              className="relative overflow-hidden rounded-3xl border border-gray-200/50"
              style={{ backgroundColor: rec.bg }}
            >
              {/* Header Bar */}
              <div className="flex items-center justify-between border-b border-white/5 px-5 py-4">
                <span className="text-sm font-medium tracking-wide text-white/90">{rec.source}</span>
                <div className="h-3 w-3 rounded-full" style={{ backgroundColor: rec.hex }} />
              </div>

              {/* Image Container with inner dark fade */}
              <div className="relative max-h-[450px] overflow-hidden sm:max-h-[500px]">
                <img src={rec.image} alt={rec.alt} className="h-auto w-full object-top" loading="lazy" />

                {/* Fade to dark background instead of transparent page background */}
                <div
                  className={`absolute inset-x-0 bottom-0 bg-gradient-to-t to-transparent ${rec.fadeHeight}`}
                  style={{
                    backgroundImage: `linear-gradient(to top, ${rec.bg} ${rec.fadePercentage}, transparent 100%)`,
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
